import request from '@/utils/request'

//引入
// import touristApi from '@/api/system/home/home.js'

//使用
// homeApi.houseCustomTagList().then((res) => {
//   if (res.code == 200) {
//     this.$message.success('查询房源自定义标签列表')
//     this.customTagList = res.data
//   }
// })

export default {
  // 综合报表列表
  comprehensiveStatistics(query) {
    return request({
      url: '/comprehensiveStatistics/list',
      method: 'get',
      params: query
    })
  },
}